import React            from 'react';

class Privacy extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                <br/><br/>
                <span>
                Updated August 2026<br/><br/>

We value your privacy. This app does not collect, store, or share any personal information. No user data such as location, contacts, device information, or usage activity—is collected at any time.
<br/><br/>
We do not store any personal data on our servers or within the app, and we do not sell, rent, or disclose any data to third parties.
<br/><br/>
Since no personal data is collected, there is no need for data management, retention, or deletion.
<br/><br/>
If you have any questions about this privacy policy, please contact us at admin@flowerdustmusic.com.
                    <br/><br/>
                    </span>
                <br/><br/>
            </div>
        );}
}
export default Privacy;
